import React, { FC } from 'react';
import { Tabs as AntdTabs, TabPaneProps as AntdTabPaneProps } from 'antd';

const TabPane: FC<AntdTabPaneProps> = (props) => {
  return <AntdTabs.TabPane forceRender {...props} />;
};

export default TabPane;
